import Raharja1 from './Raharja.webp'
import Raharja2 from './Raharja.webp'


const Raharjaimages =[
Raharja1,Raharja2
]

export default Raharjaimages;